import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import history from '../../../../route/history'
import moment from 'moment'
import CertificateAddDoc from './CertificateAddDoc'
import CertificateReceiver from './CertificateReceiver'
import { alertActions, authActions, commonActions, inboxActions } from '../../../../store/actions'
import Alert from '../../../../module/alert/Alert'

const CertificateSubmit = (props) => {
  const queryString = require('query-string')

  const [state, setState] = useState({})
  const [historyInfo, setHistoryInfo] = useState({})
  const [addList, setAddList] = useState([])
  const [receiverList, setReceiverList] = useState([])
  const [crtDvList, setCrtDvList] = useState([])
  const [crtStsCdList, setCrtStsCdList] = useState([])

  useEffect(() => {
    const locationInfo = history.location.state

    // 제출의 경우 목록에서 바로 접근과 상세보기에서 접근 가능
    if (locationInfo.selectedSubject) {
      setHistoryInfo({
        ...historyInfo,
        selectedSubject: locationInfo.selectedSubject,
        tabStatus: locationInfo.tabStatus,
        srhFrom: locationInfo.srhFrom,
        srhTo: locationInfo.srhTo,
        srhKind: locationInfo.srhKind,
        pageIdx: locationInfo.pageIdx || 1,
      })
    }

    props.common({ mainCd: ['CRT_STS_CD', 'CRT_DV'] })

    return () => {
      props.addReceiverInfo([])
      props.onClear()
    }
  }, [])

  useEffect(() => {
    if (props.isSubmit) {
      props.success({
        title: '제출성공',
        message: '성공적으로 제출되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            history.replace('/service/inbox')
          },
        },
      })
    }
  }, [props.isSubmit])

  useEffect(() => {
    if (!props.commoncode) return

    setCrtDvList(props.commoncode?.CRT_DV)

    setCrtStsCdList(props.commoncode?.CRT_STS_CD)
  }, [props.commoncode])

  const goList = () => {
    if (historyInfo.selectedSubject) {
      let paramStr = queryString.stringify(historyInfo)
      paramStr.length > 0 && (paramStr = '?' + paramStr)
      history.push('/service/inbox' + paramStr)
    } else {
      // 상세를 통해서 접근시 그냥 goBack
      history.goBack()
    }
  }

  const getAddList = (addList) => {
    setAddList(addList)
  }

  const getReceiverList = (receiverList) => {
    setReceiverList(receiverList)
  }

  const onSubmit = () => {
    // 증명서 보내기
    // 1. 업체id, 전자문서코드, 첨부파일, 제출처 전자지갑 주소를 입력받아 필수 입력항목 체크
    // 2. 증명서 송신 api 호출(처리결과 메시지 출력)
    // 3. 목록으로 이동

    if (receiverList.length < 1) {
      props.error({ message: '수신 대상이 존재하지 않습니다.' })
      return
    }

    let submitObj = {
      crtSeq: props.inboxInfo.crtSeq,
      files: addList,
      ewalletIds: receiverList.map((receiver) => receiver.ewalletId),
    }

    props.createCrtfSubmit(submitObj)
  }

  const makeCrtCd = (crtCd) => {
    const list = crtDvList?.find((crtDv) => crtDv?.cd === crtCd)

    return list ? '[' + list.cdName + ']' : ''
  }

  const makeCrtStsCd = (sts) => {
    const list = crtStsCdList?.find((crtSts) => crtSts.cd === sts)

    return list ? list.cdName : ''
  }

  return (
    <React.Fragment>
      <div className="detail-table">
        <div className="service-title">
          <button className="btn btn-white btn-pre" onClick={goList}>
            <span>이전페이지로 이동</span>
          </button>
          증명서 제출
        </div>
        <div className="detail-table-box">
          <div className="detail-title">증명서</div>
          <div className="detail-table-scroll">
            <div className="inner">
              <div className="scroll">
                <div className="row" style={{ width: '100%' }}>
                  <ul className="flex-col">
                    <li className="flex-sb w-full ">
                      <div className="flex-row w-full item">
                        <span className="title w-50">
                          {makeCrtCd(props.inboxInfo?.crtCd)} - {makeCrtStsCd(props.inboxInfo?.sts)}
                        </span>
                        <span className="w-50 text-right">
                          {moment(props.inboxInfo?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD HH:mm:ss')}
                        </span>
                      </div>
                    </li>
                    <li className="flex-sb w-full">
                      <div className="flex-row w-full item">
                        <span className="">{props.inboxInfo?.docid}</span>
                      </div>
                    </li>
                    <li className="flex-sb w-full">
                      <div className="flex-row w-full item">
                        <span className="w-50">{props.inboxInfo?.prchsNm}</span>
                        <span className="w-50 text-right">{props.inboxInfo?.gramt}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CertificateAddDoc getAddList={getAddList} />
        <CertificateReceiver getReceiverList={getReceiverList} />

        <div className="w-100 text-center">
          <button className="btn btn-dark-blue" onClick={onSubmit}>
            증명서 보내기
          </button>
        </div>
      </div>
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    inboxInfo: state.inbox?.info,
    commoncode: state.commoncode?.co,
    isSubmit: state.inbox?.isSubmit,
  }
}

const actionCreators = {
  addReceiverInfo: inboxActions.addReceiverInfo,
  createCrtfSubmit: inboxActions.createCrtfSubmit,
  common: commonActions.getCommonCode,
  success: alertActions.success,
  error: alertActions.error,
  onClear: inboxActions.onClear,
}

export default connect(mapStateToProps, actionCreators)(CertificateSubmit)
